import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  chip: {
    margin: "5px 5px 5px 0",
  },
  subtitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "10px",
    color: "#FFFFFF",
  },
  spacing: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#FFFFFF",
  },
  card: {
    backgroundColor: "#8731EB",
    color: "#FFFFFF",
    borderRadius: 25,
  },
  links: {
    color: "#FFFFFF",
  },
}));
